
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my/boards",
      function () {
        return require("private-next-pages/my/boards/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my/boards"])
      });
    }
  